
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Programs from "../pages/programs/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/programas",
    element: <Programs />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
